import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const currentUser = this.authService.currentUserValue;
    // Asumo que el token está dentro de currentUser o en localStorage.
    // Ajusta esto según donde guardes el string del token real:
    const token = localStorage.getItem('token'); 

    // 1. Verificamos si existe usuario Y token
    if (currentUser && token) {
        
        // 2. Verificamos si el token NO ha expirado
        if (!this.isTokenExpired(token)) {
            return true; // Token válido, pasa.
        }
    }
    
    // Limpiamos sesión por si acaso quedó basura vieja
    this.authService.logout(); 
    
    // Guardamos la URL para volver después
    // (Nota: asegúrate de no guardar la URL si ya estás redirigiendo para evitar bucles)
    localStorage.setItem('returnUrl', state.url);
    
    return this.router.createUrlTree(['/login']);
  }

  // --- Función auxiliar para verificar expiración ---
  private isTokenExpired(token: string): boolean {
    try {
      // El payload es la segunda parte del token (separado por puntos)
      const payloadBase64 = token.split('.')[1];
      
      // Decodificamos el Base64 a string JSON
      const decodedJson = atob(payloadBase64);
      const payload = JSON.parse(decodedJson);

      // Verificamos el campo 'exp' (expiration)
      if (!payload.exp) {
        return false; // Si no tiene expiración, asumimos que no expira (o true si prefieres estricto)
      }

      const currentTime = Math.floor(Date.now() / 1000); // Tiempo actual en segundos

      // Si el tiempo actual es mayor que la expiración, devolvemos true (expiró)
      return currentTime >= payload.exp;

    } catch (e) {
      // Si el token tiene formato incorrecto, asumimos que está "expirado/inválido"
      return true;
    }
  }
}